<a (click)="shareOnFacebook()" ngbTooltip="Distribuie pe Facebook" container="body"
  class="btn btn-secondary btn-icon btn-sm btn-facebook rounded-circle me-3 mb-3" role="button">
  <i class="ai-facebook"></i>
</a>
<a [href]="whatsappShareUrl" target="_blank" ngbTooltip="Distribuie pe WhatsApp" container="body"
  class="btn btn-secondary btn-icon btn-sm btn-whatsapp rounded-circle me-3 mb-3" role="button">
  <i class="ai-whatsapp"></i>
</a>
<a (click)="shareOnMessenger()" ngbTooltip="Distribuie pe Facebook Messenger" container="body"
  class="btn btn-secondary btn-icon btn-sm btn-messenger rounded-circle me-3 mb-3 d-none d-sm-inline-flex" role="button">
  <i class="ai-messenger"></i>
</a>
<a [href]="facebookMessengerShareUrl" target="_blank" ngbTooltip="Distribuie pe Facebook Messenger" container="body"
  class="btn btn-secondary btn-icon btn-sm btn-messenger rounded-circle me-3 mb-3 d-inline-flex d-sm-none" role="button">
  <i class="ai-messenger"></i>
</a>
<a href="https://twitter.com/intent/tweet?url={{url}}" onclick="javascript:window.open(this.href,
'', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');return false;"
  ngbTooltip="Distribuie pe Twitter" container="body" class="btn btn-secondary btn-icon btn-sm btn-twitter rounded-circle me-3 mb-3"
  role="button">
  <i class="ai-twitter"></i>
</a>
<a (click)="copyLinkToClipboard()" ngbTooltip="Copiaza link" container="body"
  class="btn btn-secondary btn-icon btn-sm bg-secondary rounded-circle mb-3" role="button">
  <i class="ai-copy"></i>
</a>
